import { useLocation } from 'react-router-dom';

//todo : merge with UrlHelper.ts
export const useQuery = <T extends Record<string, unknown>>(): T => {
    return useQueryCore(useLocation());
};

export const useQueryCore = <T extends Record<string, unknown>>(location: { search: string }): T => {
    const query = new URLSearchParams(location.search);
    const results: Record<string, unknown> = {};
    query.forEach((value: string, key: string) => {
        results[key] = value;
    });
    return results as T;
};
